export default class Faq {

    constructor(elem) {
        this.elements = {
            holder: elem,
        }

        this.elements.triggers = this.elements.holder.querySelectorAll('.js-trigger');

        if(this.elements.triggers.length) {
            this._setDOMReferences();
        }
    }

    _setDOMReferences() {
        for (let i = 0; i < this.elements.triggers.length; i++) {
            const parent = this.elements.triggers[i].parentNode;
            this.elements.triggers[i].addEventListener("click", () => this.toggleItem(parent));
        }
    }

    toggleItem(elem) {
        if(elem.classList.contains('is--open')) {
            elem.classList.remove('is--open');
        } else {
            elem.classList.add('is--open');
        }
    }

}